import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "Estudiantes sin asignar", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "subtitle" }, "Selecciona a los estudiantes que quieras asignar y arrástralos a la derecha, para asignarlos al grupo de cada tutor.", -1)
const _hoisted_4 = { class: "p-d-flex p-grid p-jc-between" }
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = {
  key: 1,
  class: "pi pi-question-circle"
}
const _hoisted_7 = { class: "p-d-flex p-jc-center" }
const _hoisted_8 = { class: "p-d-flex p-jc-center" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" No hay estudiantes sin asignar. ")
const _hoisted_10 = ["onDrop"]
const _hoisted_11 = { class: "font-weight-700" }
const _hoisted_12 = ["onDrop"]
const _hoisted_13 = { class: "p-d-flex font-weight-700" }
const _hoisted_14 = ["src", "alt"]
const _hoisted_15 = {
  key: 1,
  class: "pi pi-question-circle"
}
const _hoisted_16 = { class: "p-d-flex p-jc-center" }
const _hoisted_17 = { class: "p-d-flex p-jc-center" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" No hay estudiantes asignados. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BrainSpinner = _resolveComponent("BrainSpinner")!
  const _component_Column = _resolveComponent("Column")!
  const _component_CoderBadge = _resolveComponent("CoderBadge")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _directive_tooltip = _resolveDirective("tooltip")!
  const _directive_parentclass = _resolveDirective("parentclass")!

  return (!_ctx.tutors || _ctx.loadingStudents || _ctx.loading)
    ? (_openBlock(), _createBlock(_component_BrainSpinner, { key: 0 }))
    : (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "p-col-4",
            draggable: "true",
            onDragstart: _cache[4] || (_cache[4] = ($event: any) => (_ctx.startDrag($event, 'unassigned')))
          }, [
            _createVNode(_component_DataTable, {
              value: _ctx.unassignedStudent,
              responsiveLayout: "scroll",
              selection: _ctx.selectedUnassignedStudents,
              "onUpdate:selection": _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectedUnassignedStudents = $event)),
              dataKey: "user.personId",
              class: "p-datatable-ssm no-border-radius-header unassigned-table",
              onDrop: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onDrop($event, 'unassigned'))),
              onDragenter: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"])),
              onDragover: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
            }, {
              empty: _withCtx(() => [
                _hoisted_9
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  selectionMode: "multiple",
                  class: "content-jc-center no-border",
                  headerStyle: "width: 3em;",
                  headerClass: "header-thin"
                }),
                _createVNode(_component_Column, {
                  field: "profile.name",
                  header: "Nombre",
                  headerClass: "header-thin no-border"
                }, {
                  body: _withCtx(({ data }) => [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", null, _toDisplayString(data.profile?.name) + " " + _toDisplayString(data.profile?.lastName), 1)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "profile.country",
                  bodyClass: "p-text-center",
                  headerClass: "header-thin no-border"
                }, {
                  body: _withCtx(({ data }) => [
                    (data.profile?.country && _ctx.Country.getCountryNameFromCode(data.profile?.country) !== '')
                      ? _withDirectives((_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _ctx.Country.getIconUrlFromCountryCode(data.profile?.country),
                          alt: `Bandera de ${_ctx.Country.getCountryNameFromCode(data.profile?.country)}`
                        }, null, 8, _hoisted_5)), [
                          [
                            _directive_tooltip,
                            _ctx.Country.getCountryNameFromCode(data.profile?.country),
                            void 0,
                            { blur: true }
                          ]
                        ])
                      : _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_6, null, 512)), [
                          [
                            _directive_tooltip,
                            'Desconocido',
                            void 0,
                            { blur: true }
                          ]
                        ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "data.user.courseModality",
                  headerClass: "header-thin"
                }, {
                  body: _withCtx(({ data }) => [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_CoderBadge, {
                        text: `${ data.user?.courseModality === _ctx.StudentCourseModality.Beca ? 'Beca' : 'Pro'}`,
                        backgroundColor: `${ data.user?.courseModality === _ctx.StudentCourseModality.Beca ? '#393B43' : '#5140AA'}`,
                        fontSize: '12px',
                        textColor: '#FFFFFF',
                        rounded: "",
                        padding: '4px 8px'
                      }, null, 8, ["text", "backgroundColor"])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "user.typeStudent",
                  header: "Estados",
                  headerClass: "header-thin no-border jc-center"
                }, {
                  body: _withCtx(({ data }) => [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_CoderBadge, {
                        text: _ctx.getTypeStudent(data.user?.type).name,
                        backgroundColor: _ctx.getTypeStudent(data.user?.type).color,
                        fontSize: '12px',
                        rounded: "",
                        padding: '4px 8px',
                        class: _normalizeClass('p-ml-0')
                      }, null, 8, ["text", "backgroundColor"])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value", "selection"])
          ], 32),
          _createElementVNode("div", {
            class: "p-col-5",
            draggable: "true",
            onDragstart: _cache[13] || (_cache[13] = ($event: any) => (_ctx.startDrag($event, 'assigned')))
          }, [
            _createVNode(_component_DataTable, {
              class: "p-datatable-ssm no-border-radius-header unassigned-table",
              rowGroupMode: "subheader",
              value: Array.from(_ctx.tutors.values()),
              responsiveLayout: "scroll",
              expandedRows: _ctx.expandedRows,
              "onUpdate:expandedRows": _cache[12] || (_cache[12] = ($event: any) => (_ctx.expandedRows = $event))
            }, {
              expansion: _withCtx(({ data }) => [
                _createVNode(_component_DataTable, {
                  class: "p-datatable-ssm column-header no-border-header students-table",
                  value: _ctx.assignedStudent.get(data.id),
                  responsiveLayout: "scroll",
                  dataKey: "user.personId",
                  selection: _ctx.selectedAssignedStudent,
                  "onUpdate:selection": _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectedAssignedStudent = $event)),
                  onDrop: ($event: any) => (_ctx.onDrop($event, data.tutorStudentId)),
                  onDragenter: _cache[10] || (_cache[10] = _withModifiers(() => {}, ["prevent"])),
                  onDragover: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["prevent"]))
                }, {
                  empty: _withCtx(() => [
                    _hoisted_18
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_Column, {
                      selectionMode: "multiple",
                      class: "content-jc-center no-border",
                      headerStyle: "width: 3em;",
                      headerClass: "header-thin"
                    }),
                    _createVNode(_component_Column, {
                      field: "profile.name",
                      header: "Nombre",
                      headerClass: "header-thin no-border"
                    }, {
                      body: _withCtx(({ data }) => [
                        _createElementVNode("div", null, [
                          _createElementVNode("span", null, _toDisplayString(data.profile?.name) + " " + _toDisplayString(data.profile?.lastName), 1)
                        ])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_Column, {
                      field: "profile.country",
                      bodyClass: "p-text-center",
                      headerClass: "header-thin no-border"
                    }, {
                      body: _withCtx(({ data }) => [
                        (data.profile?.country && _ctx.Country.getCountryNameFromCode(data.profile?.country) !== '')
                          ? _withDirectives((_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _ctx.Country.getIconUrlFromCountryCode(data.profile?.country),
                              alt: `Bandera de ${_ctx.Country.getCountryNameFromCode(data.profile?.country)}`
                            }, null, 8, _hoisted_14)), [
                              [
                                _directive_tooltip,
                                _ctx.Country.getCountryNameFromCode(data.profile?.country),
                                void 0,
                                { blur: true }
                              ]
                            ])
                          : _withDirectives((_openBlock(), _createElementBlock("i", _hoisted_15, null, 512)), [
                              [
                                _directive_tooltip,
                                'Desconocido',
                                void 0,
                                { blur: true }
                              ]
                            ])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_Column, {
                      field: "data.user.courseModality",
                      headerClass: "header-thin"
                    }, {
                      body: _withCtx(({ data }) => [
                        _createElementVNode("div", _hoisted_16, [
                          _createVNode(_component_CoderBadge, {
                            text: `${ data.user?.courseModality === _ctx.StudentCourseModality.Beca ? 'Beca' : 'Pro'}`,
                            backgroundColor: `${ data.user?.courseModality === _ctx.StudentCourseModality.Beca ? '#393B43' : '#5140AA'}`,
                            fontSize: '12px',
                            textColor: '#FFFFFF',
                            rounded: "",
                            padding: '4px 8px'
                          }, null, 8, ["text", "backgroundColor"])
                        ])
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_component_Column, {
                      field: "user.typeStudent",
                      header: "Estados",
                      headerClass: "header-thin no-border jc-center"
                    }, {
                      body: _withCtx(({ data }) => [
                        _createElementVNode("div", _hoisted_17, [
                          _createVNode(_component_CoderBadge, {
                            text: _ctx.getTypeStudent(data.user?.type).name,
                            backgroundColor: _ctx.getTypeStudent(data.user?.type).color,
                            fontSize: '12px',
                            rounded: "",
                            padding: '4px 8px',
                            class: _normalizeClass('p-ml-0')
                          }, null, 8, ["text", "backgroundColor"])
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1032, ["value", "selection", "onDrop"])
              ]),
              default: _withCtx(() => [
                _createVNode(_component_Column, {
                  expander: true,
                  headerStyle: "width: 1rem",
                  class: "bg-gray-300",
                  headerClass: "header-thin no-border"
                }),
                _createVNode(_component_Column, {
                  field: "fullName",
                  header: "Tutor",
                  headerClass: "header-thin"
                }, {
                  body: _withCtx(({ data }) => [
                    _createElementVNode("span", {
                      class: "dropeable-content",
                      onDrop: ($event: any) => (_ctx.onDrop($event, data.tutorStudentId)),
                      onDragenter: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
                      onDragover: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"]))
                    }, null, 40, _hoisted_10),
                    _withDirectives(_createElementVNode("div", _hoisted_11, [
                      _createElementVNode("span", null, _toDisplayString(data.fullName), 1)
                    ], 512), [
                      [_directive_parentclass, ['bg-gray-300','p-d-relative']]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_Column, {
                  field: "assignedStudents",
                  header: "Cantidad de asignados",
                  headerClass: "header-thin"
                }, {
                  body: _withCtx(({ data }) => [
                    _createElementVNode("span", {
                      class: "dropeable-content",
                      onDrop: ($event: any) => (_ctx.onDrop($event, data.tutorStudentId)),
                      onDragenter: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"])),
                      onDragover: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"]))
                    }, null, 40, _hoisted_12),
                    _withDirectives(_createElementVNode("div", _hoisted_13, [
                      _createVNode(_component_CoderBadge, {
                        text: 
                    `${_ctx.assignedStudent.get(data.id)?.length ?? 0} ${
                      _ctx.assignedStudent.get(data.id)?.length === 1
                        ? 'Estudiante'
                        : 'Estudiantes'
                    }`
                  ,
                        backgroundColor: _ctx.assignedStudent.get(data.id)?.length > 0 ? 'rgba(163, 200, 131, 0.6)' : 'rgba(248, 131, 131, 0.6)',
                        fontSize: '12px'
                      }, null, 8, ["text", "backgroundColor"])
                    ], 512), [
                      [_directive_parentclass, ['bg-gray-300','p-d-relative']]
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["value", "expandedRows"])
          ], 32)
        ])
      ]))
}